import { css } from '@emotion/react';
import { theme } from 'global';

export const statusOutcome = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 32px;
  padding: 24px 32px;
  border: 1px solid ${theme.colors.neutral[100]};

  > div.text-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  > button {
    min-width: 137px;
    height: 44px;
  }

  @media screen and (max-width: ${theme.breaks.sm}px) {
    flex-direction: column;
    gap: 16px;

    > button {
      min-width: 116px;
      height: 44px;
    }
  }
`;

export const declinedOutcome = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
  max-width: 744px;
  text-align: center;

  @media screen and (max-width: ${theme.breaks.sm}px) {
    margin-bottom: 48px;
  }
`;
